// extracted by mini-css-extract-plugin
export var appContainer = "OldMobileBanner_appContainer__SUTXQ";
export var container = "OldMobileBanner_container__daZ+O";
export var dbClose = "OldMobileBanner_dbClose__mvc3X";
export var dbCloseIcon = "OldMobileBanner_dbCloseIcon__wiAd+";
export var description = "OldMobileBanner_description__4M0Dq";
export var details = "OldMobileBanner_details__9-Xgh";
export var logoImage = "OldMobileBanner_logoImage__6Sp03";
export var openButton = "OldMobileBanner_openButton__lv2v4";
export var title = "OldMobileBanner_title__AFfOv";